import './index.scss'

export default () => <div class="loader overlay  ripple" ></div>
/*
export default () => 
<div className='loader-container'>
    <div class="loader overlay medium">
        <label className='overlay--label'>
            Loading, please wait...
        </label>
        </div>
    </div>
    */